export default {
  name: "Paging",
  //通过props来接受从父组件传递过来的值
  props: {
    pageData: {
      //当前页数
      pageIndex: {
        type: Number,
        default: 1
      },
      //页面中的可见页码，其他的以...代替，必须是奇数
      pageCount: {
        type: Number,
        default: 11
      },
      //总记录数
      pageTotal: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 10
      },
      //总记录数
      dataTotal: {
        type: Number,
        default: 1
      }
    },
    refreshShow: {
      type: Boolean,
      default: false
    },
    selectSize: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    refresh() {
      //刷新
      this.$parent.$parent.setPage(this.index);
    },
    //上一页
    prev() {
      if (this.index > 1) {
        this.go(this.index - 1);
      }
    },
    //下一页
    next() {
      if (this.index < this.pageTotal) {
        this.go(this.index + 1);
      }
    },
    //第一页
    first() {
      if (this.index !== 1) {
        this.go(1);
      }
    },
    //最后一页
    last() {
      if (this.index != this.pageTotal) {
        this.go(this.pageTotal);
      }
    },
    //跳转页面
    go(page) {
      page = parseInt(page);
      if (page == NaN || !page) {
        page = 1;
        return false;
      }
      if (this.index !== page) {
        this.index = page;
        if (this.index > this.pageTotal) {
          this.index = this.pageTotal;
        }
        //父组件通过setPage方法来接受当前的页码
        this.$emit("setPage", this.index);
      }
    },
    chooseSize() {
      this.$emit("setSize", this.page_size);
    }
  },
  created() {
    if (this.pageData.pageSize) {
      this.page_size = this.pageData.pageSize;
      if (!this.page_size_list.includes(this.page_size)) {
        this.page_size_list.push(this.page_size);
      }
      this.page_size_list.sort((a, b) => {
        return a - b;
      });
    }
  },
  computed: {
    //计算页码，当count等变化时自动计算
    pagers() {
      const array = [];
      const pageCount = this.pageData.pageCount;
      const pageTotal = this.pageTotal;
      let current = this.index;
      const _offset = (pageCount - 1) / 2;
      let offset = {
        start: current - _offset,
        end: current + _offset
      };
      if (pageCount % 2 == 0) {
        offset.start = parseInt(offset.start);
        offset.end = parseInt(offset.end) + 1;
        if (current > _offset) {
          offset.end = parseInt(offset.end - 1);
        }
      }
      //-1, 3
      if (offset.start < 1) {
        offset.end = offset.end + (1 - offset.start);
        offset.start = 1;
      }
      if (offset.end > pageTotal) {
        offset.start = offset.start - (offset.end - pageTotal);
        offset.end = pageTotal;
      }
      if (offset.start < 1) offset.start = 1;

      this.showPrevMore = offset.start > 1;
      this.showNextMore = offset.end < pageTotal;
      for (let i = offset.start; i <= offset.end; i++) {
        array.push(i);
      }
      return array;
    },
    pageTotal() {
      return this.pageData.pageTotal >= 0
        ? this.pageData.pageTotal
        : 10000000000000;
    },
    showPagsTotal() {
      let s = this.pageData.pageTotal >= 0 ? true : false;
      if (this.pageData.pageTotal == 10000000000000) {
        a = false;
      }
      return s;
    }
  },
  data() {
    return {
      index: this.pageData.pageIndex, //当前页码
      current: this.pageData.pageIndex, //跳转页至页码输入框
      showPrevMore: false,
      showNextMore: false,
      page_size_list: [10, 20, 30, 50, 100],
      page_size: 10
    };
  },
  watch: {
    "pageData.pageIndex": function(val) {
      this.index = val || 1;
      this.current = this.index;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/common/paging/main.js